"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageNavigation = void 0;
var _react = require("react");
var _reactStickyEl = _interopRequireDefault(require("react-sticky-el"));
var _reactUse = require("react-use");
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _redux = require("../../packages/redux");
var _analytics = _interopRequireWildcard(require("../analytics"));
var _breakpoints = require("../breakpoints");
var _DesktopNavigation = _interopRequireDefault(require("./DesktopNavigation"));
var _index = _interopRequireWildcard(require("./index.ducks"));
var _index2 = require("./index.styled");
var colors = _interopRequireWildcard(require("./index.themes"));
var _MobileNavigation = _interopRequireDefault(require("./MobileNavigation"));
var _jsxRuntime = require("react/jsx-runtime");
const isValidHash = function () {
  let hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return hash.length > 1 && hash[0] === "#";
};
const pageTopAriaLabel = "Scroll to the top of the page";
function scrollToElement(element) {
  element === null || element === void 0 ? void 0 : element.scrollIntoView(true);
  setTimeout(function () {
    return focusFirstElement(element);
  }, 0);
}
function focusFirstElement(element) {
  if (!element) return undefined;
  const elements = [...element.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')].filter(function (el) {
    return !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden");
  });
  const focus = elements[0];
  if (focus) {
    focus.focus({
      preventScroll: true
    });
  }
  return focus;
}
const PageNavigation = function (_ref) {
  let {
    id = "subNavigation",
    className,
    links = [],
    titleHref = "#",
    titleTarget = "",
    titleAriaLabel = "",
    breakpoints = ["desktop", "tablet", "mobile"],
    mode = "default",
    subnavTitle = "",
    shortName,
    selectedUnderlineColor = "",
    ctas = [],
    useScrollableCta = false
  } = _ref;
  const [select, dispatch] = (0, _redux.useReducerManager)({
    id,
    reducer: _index.default,
    initialState: _index.initialState
  });
  const elementsOnScreen = (0, _react.useRef)([]);
  const activeLink = select(_index.getCurrentNavId);
  const fireAnalytics = (0, _analytics.default)("PageNavigation");
  const selectedItemIndex = links.findIndex(function (link) {
    return link.isActive;
  });
  const [showBuildCTA, setShowBuildCTA] = (0, _react.useState)(!useScrollableCta);
  const trackSections = (0, _react.useCallback)(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var _entry$rootBounds$y, _entry$rootBounds;
        const isAbove = entry.boundingClientRect.y < ((_entry$rootBounds$y = (_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.y) !== null && _entry$rootBounds$y !== void 0 ? _entry$rootBounds$y : 0);
        if (!isAbove) {
          elementsOnScreen.current.push(entry.target);
        } else {
          elementsOnScreen.current.unshift(entry.target);
        }
      } else {
        elementsOnScreen.current = elementsOnScreen.current.filter(function (i) {
          return i !== entry.target;
        });
      }
      if (elementsOnScreen.current[0]) {
        const linkId = elementsOnScreen.current[0].getAttribute("id");
        const linkIndex = links.findIndex(function (link) {
          var _link$href;
          return (link === null || link === void 0 ? void 0 : (_link$href = link.href) === null || _link$href === void 0 ? void 0 : _link$href.substr(1)) === linkId;
        });
        if (linkId) {
          dispatch((0, _index.updateNavigation)({
            url: linkId,
            id: linkIndex
          }));
        } else {
          dispatch((0, _index.updateNavigation)({
            url: undefined,
            id: undefined
          }));
        }
      }
    });
  }, [dispatch, links]);
  (0, _reactUse.useMount)(function () {
    const observer = new IntersectionObserver(trackSections, {
      rootMargin: "-60px 0px 0px 0px",
      threshold: 0
    });
    if (selectedItemIndex > -1) {
      dispatch((0, _index.updateNavigation)({
        url: links[selectedItemIndex].href,
        id: selectedItemIndex
      }));
    } else {
      const hashes = links.filter(function (link) {
        return isValidHash(link.href);
      });
      hashes.forEach(function (hash) {
        const mountObserver = new MutationObserver(function () {
          const elm = document.querySelector(hash.href);
          if (elm && document.contains(elm)) {
            observer.observe(elm);
            mountObserver.disconnect();
          }
        });
        mountObserver.observe(document, {
          attributes: false,
          childList: true,
          characterData: false,
          subtree: true
        });
      });
      dispatch((0, _index.updateNavigation)({
        url: undefined,
        id: undefined
      }));
    }
    return function () {
      return observer.disconnect();
    };
  });
  const onClick = function () {
    let section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    let sectionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function () {
      fireAnalytics("click", {
        href: section.toLowerCase(),
        index: sectionId,
        count: links.length,
        text: links[sectionId].text
      });
    };
  };
  const scrollToSection = function (_ref2) {
    let {
      target
    } = _ref2;
    let analytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!analytics) {
      return false;
    }
    return fireAnalytics("click", {
      href: target.baseURI
    });
  };
  const titleClick = function () {
    fireAnalytics("titleClick");
  };
  const toggleCTAButton = function (status) {
    if (useScrollableCta) {
      // If the feature is enabled, we want to toggle the cta
      setShowBuildCTA(status);
    }
  };
  const theme = (0, _styledComponentThemes.useTheme)();
  const commonProps = {
    id,
    className,
    subnavTitle,
    titleHref,
    titleTarget,
    titleAriaLabel: titleAriaLabel ? titleAriaLabel : titleHref === "#" ? pageTopAriaLabel : undefined,
    shortName,
    links,
    mode,
    ctas,
    theme,
    scrollToSection,
    onClick,
    titleClick,
    activeLink,
    selectedUnderlineColor,
    showBuildCTA
  };
  const flags = {
    mobile: (0, _breakpoints.useMobileBreakpoint)(),
    tablet: (0, _breakpoints.useTabletBreakpoint)(),
    desktop: (0, _breakpoints.useDesktopBreakpoint)({
      up: true
    })
  };
  const breakpointToCheck = Object.keys(flags).find(function (k) {
    return flags[k];
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.GlobalStyle, {}), breakpointToCheck && breakpoints.includes(breakpointToCheck) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactStickyEl.default, {
      onFixedToggle: function (status) {
        toggleCTAButton(status);
      },
      isIOSFixEnabled: false,
      stickyStyle: {
        zIndex: 5
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          position: "relative",
          zIndex: 4
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_breakpoints.TabletBreakpoint, {
          down: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileNavigation.default, {
            ...commonProps,
            theme: theme.toString()
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_breakpoints.DesktopBreakpoint, {
          up: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DesktopNavigation.default, {
            ...commonProps,
            theme: theme.toString(),
            links: links
          })
        })]
      })
    })]
  });
};
exports.PageNavigation = PageNavigation;
var _default = exports.default = (0, _analytics.withAnalytics)((0, _styledComponentThemes.withThemes)(PageNavigation, colors))({});